module.exports = __webpack_public_path__ + "static/img/formHeader.e9459c5b.png";